// extracted by mini-css-extract-plugin
export default {"wrap":"RouteFallback_wrap__mUCVz","spinner":"RouteFallback_spinner__Z5kca","spin":"RouteFallback_spin__natJ3"};